"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../libs/utils");

var _label = _interopRequireDefault(require("./label"));

var _container = _interopRequireDefault(require("./styled/container"));

var _innerContainer = _interopRequireDefault(require("./styled/innerContainer"));

var PrimitiveCheckbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PrimitiveCheckbox, _Component);

  function PrimitiveCheckbox(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PrimitiveCheckbox);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PrimitiveCheckbox).call(this, props));
    _this.inputId = (0, _utils.uniqueId)('input-checkbox');
    _this.inputRef = _react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(PrimitiveCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var checked = this.props.checked;
      this.inputRef.current.indeterminate = checked === 'indeterminate';
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevChecked = prevProps.checked;
      var checked = this.props.checked;

      if ((0, _typeof2["default"])(prevChecked) !== (0, _typeof2["default"])(checked)) {
        this.inputRef.current.indeterminate = checked === 'indeterminate';
      }
    }
    /**
     * Sets focus on the element.
     * @public
     */

  }, {
    key: "focus",
    value: function focus() {
      this.inputRef.current.focus();
    }
    /**
     * Sets click on the element.
     * @public
     */

  }, {
    key: "click",
    value: function click() {
      this.inputRef.current.click();
    }
    /**
     * Sets blur on the element.
     * @public
     */

  }, {
    key: "blur",
    value: function blur() {
      this.inputRef.current.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          value = _this$props.value,
          onChange = _this$props.onChange,
          label = _this$props.label,
          disabled = _this$props.disabled,
          tabIndex = _this$props.tabIndex,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onClick = _this$props.onClick,
          onKeyDown = _this$props.onKeyDown,
          id = _this$props.id,
          name = _this$props.name,
          checked = _this$props.checked;
      return _react["default"].createElement(_container["default"], {
        id: id,
        className: className,
        style: style
      }, _react["default"].createElement(_innerContainer["default"], null, _react["default"].createElement("input", {
        id: this.inputId,
        name: name,
        type: "checkbox",
        value: value,
        onChange: onChange,
        tabIndex: tabIndex,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick,
        onKeyDown: onKeyDown,
        disabled: disabled,
        checked: checked,
        ref: this.inputRef
      }), _react["default"].createElement(_label["default"], {
        label: label,
        inputId: this.inputId
      })));
    }
  }]);
  return PrimitiveCheckbox;
}(_react.Component);

exports["default"] = PrimitiveCheckbox;
PrimitiveCheckbox.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  name: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  checked: _propTypes["default"].oneOf([true, false, 'indeterminate']),
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  id: _propTypes["default"].string
};
PrimitiveCheckbox.defaultProps = {
  value: undefined,
  name: undefined,
  disabled: false,
  onChange: function onChange() {},
  tabIndex: undefined,
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onKeyDown: function onKeyDown() {},
  checked: undefined,
  className: undefined,
  style: undefined,
  id: undefined
};